import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export const useBrowserZoomLevel = () => {
  const [zoomLevel, setZoomLevel] = useState(1);

  useEffect(() => {
    const updateZoom = () => {
      if (window.outerWidth && window.innerWidth) {
        const zoom = Math.max(
          Math.round((window.outerWidth / window.innerWidth) * 100) / 100,
          1,
        );
        setZoomLevel(zoom);
        document.documentElement.style.setProperty('--zoom-level', `${zoom}`);
      }
    };

    updateZoom();

    const handleResize = debounce(updateZoom, 100);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return zoomLevel;
};
